import React from 'react'
import {Link} from '@reach/router'
import {
  BagCheckFill,
  Cart,
  CalendarEvent,
  CashStack,
  Check2Circle,
  PersonFill,
} from 'react-bootstrap-icons'
import {
  format as formatDate,
  parseISO as parseDateISO
} from 'date-fns'

import {formatCurrency} from '../../utils/numbers'

interface Props {
  order: any
}

export default function OrderItem({order}: Props) {
  const createDate = parseDateISO(order.created)

  return (
    <Link
      to={`/verslun/pantanir/${order.token}/`}
      className="card-hover-wrapper text-reset"
    >
      <div className="card border-0 rounded bg-white overflow-hidden">
        <div className="d-flex justify-content-between align-items-center p-4 border-bottom border-light">
          <h5 className="mb-0"><strong>Pöntun</strong> #{order?.id}</h5>
          <div className="d-flex align-items-center">
            <CalendarEvent size={13} className="text-black-50 mr-2" />
            <p className="mb-0 text-black-50"><small>{formatDate(createDate, 'd. MMM yyyy')}</small></p>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center p-4">
          <div className="d-flex flex-column">
            <div className="d-flex align-items-center mb-2">
              <Check2Circle size={20} className="mr-3 text-primary" />
              <p className="mb-0 text-dark">{order?.status}</p>
            </div>
            <div className="d-flex align-items-center mb-2">
              <Cart size={20} className="mr-3 text-primary" />
              <p className="mb-0 text-dark">{order?.lines?.length}</p>
            </div>
            <div className="d-flex align-items-center">
              <CashStack size={20} className="mr-3 text-primary" />
              <p className="mb-0 text-dark"><strong>{formatCurrency(order?.total_net_amount ?? 0)} kr.</strong></p>
            </div>
          </div>

          <div className="pr-4">
            <BagCheckFill size={80} className="text-light card-hover-icon" />
          </div>
        </div>

        <div className="d-flex justify-content-end align-items-center px-4 py-3 border-top border-light">
          <PersonFill size={15} className="mr-2 text-dark" />
          <p className="mb-0 text-dark"><small>{order?.user?.name}</small></p>
        </div>
      </div>
    </Link>
  )
}
